import React, { ReactNode } from 'react';

interface ListboxWrapperProps {
  children: ReactNode;
}

export const ListboxWrapper: React.FC<ListboxWrapperProps> = ({ children }) => (
  <div className="w-full border-small px-2 py-2 rounded-md border-default-200 dark:border-default-100">
    {children}
  </div>
);